module.exports = __webpack_public_path__ + "img/king-upgrade.303e316d.gif";